import { render, staticRenderFns } from "./tamperRecord.vue?vue&type=template&id=1f5d1602&scoped=true&"
import script from "./tamperRecord.vue?vue&type=script&lang=js&"
export * from "./tamperRecord.vue?vue&type=script&lang=js&"
import style0 from "./tamperRecord.vue?vue&type=style&index=0&id=1f5d1602&lang=scss&scoped=true&"
import style1 from "./tamperRecord.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5d1602",
  null
  
)

export default component.exports